/** WebSocket event envelope. Mirrors apps/api/app/core/events.py. */
export const ENVELOPE_VERSION = 1;

export type Channel = 'market' | 'system' | 'signals' | 'sr';

export type EventType =
  | 'heartbeat'
  | 'market.quote'
  | 'market.candle'
  | 'market.provider'
  | 'market.snapshot'
  | 'system.snapshot'
  | 'system.status'
  | 'system.backpressure'
  | 'news.updated'
  | 'signals.snapshot'
  | 'signal.status'
  | 'signal.alert'
  | 'signal.outcome'
  | 'sr.snapshot'
  | 'sr.status'
  | 'sr.notice'
  | 'sr.alert'
  | 'sr.outcome';

export interface EventEnvelope<P = Record<string, unknown>> {
  type: EventType;
  version: number;
  eventId: string;
  sequence: number;
  occurredAt: string;
  correlationId: string;
  payload: P;
}

export function isEnvelope(value: unknown): value is EventEnvelope {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.type === 'string' &&
    typeof v.version === 'number' &&
    typeof v.eventId === 'string' &&
    typeof v.sequence === 'number' &&
    typeof v.occurredAt === 'string' &&
    typeof v.payload === 'object' &&
    v.payload !== null
  );
}
